module.exports = __webpack_public_path__ + "img/sort-down.d887ac3e.png";